document.addEventListener("click", (e) => {
  const btn = e.target.closest("[quickshop-trigger], [data-trigger-quick-shopư·");
  
  if (btn) {
    setTimeout(() => {
        document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
    }, 2000);
  }
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.querySelector('#modal-cart');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "aria-hidden") {
          const isHidden = target.hasAttribute("aria-hidden");

          if (!isHidden) {
            BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');  
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["aria-hidden"]
    });
  }, 300);
}



// const observerModal = new MutationObserver(() => {
//     document.querySelectorAll("quick-shop.is-inside-modal")
//         .forEach(modal => {

//             const form = modal.querySelector("[bss-b2b-quickview-product-form]");
//             if (!form) return;

//             const link = modal.querySelector(".product-card__details a");
//             if (!link) return;

//             const observer = new MutationObserver(() => {
//                 const url = new URL(link.href, window.location.origin);
//                 const variantId = url.searchParams.get("variant");
//                 if (!variantId) return;

//                 const target = form.querySelector("[bss-b2b-variant-id]");
//                 if (!target) return;

//                 target.setAttribute("bss-b2b-variant-id", variantId);

//                 setTimeout(() => {
//                   BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {form});
//                   BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
//                   console.log("ACTIVE")
//                 }, 500);
//             });

//             observer.observe(link, {
//                 attributes: true,
//                 attributeFilter: ["href"]
//             });
//         });
// });

// observerModal.observe(document.body, {
//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: ["class"]
// });